import request from '@/utils/request'

export function getAll() {
  return request({
    url: 'client/get/last_name',
    method: 'get',
  })
}

export function get(id) {
  return request({
    url: `client/${id}`,
    method: 'get',
  })
}

export function remove(id) {
  return request({
    url: `client/${id}`,
    method: 'delete',
  })
}

export function removeQaDocFile(id, question, file) {
  return request({
    url: `client/${id}/qa-doc`,
    method: 'post',
    data: {question, file, _method: 'DELETE'}
  })
}

export function replaceQaDocFile(id, formData) {
  formData.append('_method', 'PATCH');
  return request({
    url: `client/${id}/qa-doc`,
    method: 'post',
    data: formData
  })
}
export function replaceQaDocFile1(id, formData) {
  formData.append('_method', 'PATCH');
  return request({
    url: `staff-appointment-files/${id}`,
    method: 'post',
    data: formData
  })
}

export function updateFiles(id, formData) {
  formData.append('_method', 'PATCH');
  return request({
    url:  `/appointments/${id}/files`,
    method: 'post',
    data: formData
  })
}
export function rejectQaDocsFile(id, formData) {
  return request({
    url: `client/${id}/qa-doc/reject`,
    method: 'post',
    data: formData
  })
}

export function create(data) {
  return request({
    url: 'client',
    method: 'post',
    data: data
  })
}

export function emailExists(data) {
  return request({
    url: 'client/email-exists',
    method: 'post',
    data: data
  })
}

export function update(id, data) {
  return request({
    url: `client/${id}`,
    method: 'patch',
    data: data
  })
}

export function getSession() {
  return request({
    url: `session`,
    method: 'get',
  })
}

export function deleteSession(id) {
  return request({
    url: `session/${id}`,
    method: 'delete',
  })
}
export function deleteAllSession(id) {
  return request({
    url: `session/except-current-session/`,
    method: 'post',
  })
}